<template>
  <nav class="navbar navbar-expand-lg navbar-light ">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img src="@/assets/store/img/logo.png">
      </a>
      <button class="navbar-toggler" type="button" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H21V2H0V0Z" fill="#161616"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6H21V8H0V6Z" fill="#161616"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12H21V14H0V12Z" fill="#161616"/>
        </svg>

      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/businesses-registration">GV Business</router-link>
          </li>
          <!--
          <li class="nav-item">
            <router-link class="nav-link" to="/dashboard">Client Portal</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/gv-learning">GV Portal</router-link>
          </li>
          -->
        </ul>
        <form class="d-flex">
          <button class="btn btn-outline-success signup" type="submit">
            <a href="#">Sign Up</a>
          </button>
        </form>
      </div>
    </div>
  </nav>
</template>

<style lang="scss">

@import "~@/assets/store/styles.scss";

.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px 0;
  z-index: 9;
  overflow: hidden;
  box-shadow: none;

  .container-fluid {
    padding: 0 100px;
    @media (min-width: $width1) and (max-width: $width2) {
      flex-direction: row-reverse;
      padding: 0 22px;

    }

    .navbar-brand {
      width: 184px;
      height: 55.86px;
      @media (min-width: $width1) and (max-width: $width2) {
        width: 126px;
        position: relative;
        left: -124px;


      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .navbar-toggler {
      border-color: unset;
      box-shadow: none;
      border: none;

      svg {
        width: 28px;
        height: 28px;
      }
    }

    .collapse {
      margin-left: 18%;
      @media (min-width: $width1) and (max-width: $width2) {
        text-align: center;
        margin-left: unset;
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
        background-color: rgb(216 55 81 / 50%);
        padding: 25px 10px;

      }

      ul {
        padding: 30px 0;
        @media (min-width: $width1) and (max-width: $width2) {
          padding: 0px 40px 25px 40px;
        }

        li {
          margin-right: 58px;
          @media (min-width: $width1) and (max-width: $width2) {
            border-bottom: 1px solid #d32844;
            padding: 10px 0;
            margin-right: unset;
          }

          a {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 17px;
            line-height: 20px;
            color: #161616;

          }
        }

        li:last-of-type {
          margin-right: unset;
        }
      }

      form {
        button {
          border: none;
          margin-right: 18px;
          @media (min-width: $width1) and (max-width: $width2) {
            margin-right: unset;
            margin: 0 auto;
          }

          a {
            text-decoration: none;
            font-family: Roboto;
            font-style: normal;
            font-weight: 600;
            font-size: 17px;
            line-height: 20px;
            text-align: right;
            color: #FFFFFF;

          }
        }

        .signup {
          background: #DA0A2C;
          border-radius: 68px;
          padding: 10px 50px;
        }
      }
    }
  }

}
</style>
